/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'ajs-legacy';
const componentName = 'collection-dropdown-custom';
const prefix = `${moduleName}.${componentName}`;

export const setCustomValueLabel = `${prefix}.setCustomValueLabel`;
export const customValueLabel = `${prefix}.customValueLabel`;
export const orPickOneStringIpGroupsLabel = `${prefix}.orPickOneStringIpGroupsLabel`;
export const searchInputPlaceholder = `${prefix}.searchInputPlaceholder`;
export const emptyValidEntriesLabel = `${prefix}.emptyValidEntriesLabel`;
export const createBtnLabel = `${prefix}.createBtnLabel`;

export const ENGLISH = {
    [setCustomValueLabel]: 'Set Custom Value',
    [customValueLabel]: 'Custom Value',
    [orPickOneStringIpGroupsLabel]: 'Or pick one of the following String/IP Groups',
    [searchInputPlaceholder]: 'Search',
    [emptyValidEntriesLabel]: '-- no valid entries --',
    [createBtnLabel]: 'Create',
};
